export const getGenderAndCategoryData = (productType: string) => {
  const productTypeBreakdown = productType.toLowerCase().split(':');
  const [_gender, category, subcategory] = productTypeBreakdown;
  const titlePrefix = _gender === 'men' ? "men's" : "women's";
  const gender: 'men' | 'women' = _gender === 'women' || _gender === 'men' ? _gender : 'women';
  return { gender, titlePrefix, category, subcategory };
};
